/* TipiTapi.lt – pristatymo terminas (1–2 d.d. sandėlyje / 3–9 d.d. iš tiekėjo). Duomenys: tt-kodai.js, tt-raktai.js */
(function () {
  var FAST_BRANDS = ['tutis', 'ergobaby', 'troller'];
  var TEXT_FAST = '<strong>Yra sandėlyje.</strong> <span class="tt-delivery">Pristatymo terminas: 1–2 d.d.</span>';
  var TEXT_SLOW = '<strong>Yra sandėlyje.</strong> <span class="tt-delivery">Pristatymo terminas: 3–9 d.d.</span>';
  var CODES = new Set(String(window.TT_KODAI || '').split(','));
  var KEYS = String(window.TT_RAKTAI || '').split('|').filter(Boolean).map(function (k) { return k.split(' '); });

  function normCode(c) { return String(c || '').toUpperCase().replace(/\s+/g, '').replace(/^0+/, ''); }
  function tokens(t) {
    t = String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    t = t.replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2');
    var out = new Set();
    (t.match(/[a-z0-9]+/g) || []).forEach(function (w) {
      if (/^\d+$/.test(w)) w = w.replace(/^0+/, '') || '0';
      out.add(w);
    });
    return out;
  }
  function isFast(p, v) {
    var brand = (p.vendor + ' ' + p.title).toLowerCase();
    for (var i = 0; i < FAST_BRANDS.length; i++) if (brand.indexOf(FAST_BRANDS[i]) !== -1) return true;
    if (v) {
      var s = normCode(v.sku), b = normCode(v.barcode);
      if ((s && CODES.has(s)) || (b && CODES.has(b))) return true;
    }
    var have = tokens(p.title + ' ' + (v ? v.title : ''));
    for (var k = 0; k < KEYS.length; k++) {
      var ok = true;
      for (var j = 0; j < KEYS[k].length; j++) if (!have.has(KEYS[k][j])) { ok = false; break; }
      if (ok) return true;
    }
    return false;
  }
  function init(el) {
    var p; try { p = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var cache = {}, last = null;
    function currentId() {
      var inp = form && form.querySelector('[name="id"]');
      var id = inp && inp.value;
      if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m ? m[1] : p.selected; }
      return String(id);
    }
    function render() {
      var id = currentId();
      if (id === last) return;
      last = id;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === id) v = p.variants[i];
      if (!(id in cache)) cache[id] = isFast(p, v);
      el.innerHTML = cache[id] ? TEXT_FAST : TEXT_SLOW;
      el.style.display = '';
    }
    render();
    if (form) form.addEventListener('change', function () { setTimeout(render, 50); });
    setInterval(render, 700);
  }
  function start() { document.querySelectorAll('.tt-pristatymas').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
